import { UpdateUserMetaForm } from "./UpdateUserMetaForm";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UpdateUserRights } from "./UpdateUserRights";
import { useSearchParams } from "react-router";
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import { ROUTES } from "@/constants/routeConstants";
import { useTranslation } from "react-i18next";
import { DeleteUserButton } from "./DeleteUserButton";
import { BaseFormLayout } from "@/pages/shared/BaseFormLayout";
import { UserSystemDynamicSettings } from "./UserSystemDynamicSettings";

export const UserDetailPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const userId = Number(searchParams.get("Id"));

  useBreadcrumbs([
    {
      name: t("entities.user"),
      path: ROUTES.USER,
    },
    {
      name: t("common.entityDetail", { name: t("entities.user") }),
      path: ROUTES.USER_DETAIL,
    },
  ]);

  return (
    <BaseFormLayout
      title={t("common.entityDetail", { name: t("entities.user") })}
      rightContent={<DeleteUserButton userId={userId} />}
    >
      <Tabs defaultValue={"meta"}>
        <TabsList>
          <TabsTrigger value="meta">{t("common.detail")}</TabsTrigger>
          <TabsTrigger value="rights">{t("entities.role")}</TabsTrigger>
          <TabsTrigger value="settings">{t("settings.title")}</TabsTrigger>
        </TabsList>
        <TabsContent value="meta">
          <UpdateUserMetaForm userId={userId} />
        </TabsContent>
        <TabsContent value="rights">
          <UpdateUserRights userId={userId} />
        </TabsContent>
        <TabsContent value="settings">
          <UserSystemDynamicSettings userId={userId} />
        </TabsContent>
      </Tabs>
    </BaseFormLayout>
  );
};
